import { get, post } from '../utils/fetch';

export const getUser: () => Promise<{
    access_token: string;
    info: {
        email: string;
        emailVerified: boolean;
        en: boolean;
        fn: string;
        isPhNoVerified: boolean;
        ln: string;
        mobile: string;
        name: string;
        prefix: string;
        rpr: boolean;
    };
    uid: string;
}> = async () => {
    const { data } = await post('api/v2/oauth/userinfo');
    return data;
};

export const getWallet: () => Promise<number> = async () => {
    const { data } = await get('api/v3/ixigo-money/wallet');
    return data?.balance || 0;
};
